import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  isIOS() {
    const userAgent = window.navigator.userAgent.toLowerCase(),
      macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
      iosPlatforms = /(iphone|ipad|ipod)/i;

    return macosPlatforms.test(userAgent) || iosPlatforms.test(userAgent);
  }
}
